import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Image2 from "../Images/image 2.png";
import "../Styles/HomeAbout.css";

function HomeAbout() {
  return (
    <section className="ha-section">
      <div className="ha-inner">
        <div className="ha-image">
          <img src={Image2} alt="Professional stucco team at work" />
          <div className="ha-float-card">
            <strong>15+</strong>
            <span>Years of Trusted Service</span>
          </div>
        </div>

        <div className="ha-text">
          <span className="section-label">ABOUT US</span>
          <h2>Your Trusted Stucco & Drywall Experts</h2>
          <p>
            With over 15 years in the industry, we've built our reputation on
            quality craftsmanship, honest service, and results that speak for
            themselves. Our team ensures every project meets the highest
            standards.
          </p>

          <div className="ha-checks">
            <div className="ha-check">
              <FontAwesomeIcon icon={faCheck} className="ha-check-icon" />
              <span>Licensed & Fully Insured</span>
            </div>
            <div className="ha-check">
              <FontAwesomeIcon icon={faCheck} className="ha-check-icon" />
              <span>Free Estimates</span>
            </div>
            <div className="ha-check">
              <FontAwesomeIcon icon={faCheck} className="ha-check-icon" />
              <span>Premium Quality Materials</span>
            </div>
            <div className="ha-check">
              <FontAwesomeIcon icon={faCheck} className="ha-check-icon" />
              <span>Satisfaction Guaranteed</span>
            </div>
            <div className="ha-check">
              <FontAwesomeIcon icon={faCheck} className="ha-check-icon" />
              <span>Residential & Commercial</span>
            </div>
            <div className="ha-check">
              <FontAwesomeIcon icon={faCheck} className="ha-check-icon" />
              <span>On-Time Project Delivery</span>
            </div>
          </div>

          <Link to="/about" className="ha-btn">
            More About Us →
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HomeAbout;
